export const locationPaths = {
  LOCATION_CREATE: "create",
  LOCATION_EDIT: ":id",
  LOCATION_ID: (id) => id,
  LOCATION_DELETE: "delete/:id",
  LOCATION_DELETE_ID: (id) => `delete/${id}`,
};
